import React, { useEffect } from "react";
import { useParams } from "react-router-dom"; // ✅ Needed for dynamic route
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../assets/css/main.css";
import { Link } from 'react-router-dom';
import service_img from '../assets/img/services/services-4.webp';
import transformjetLogo from '../assets/img/about/transformjet.png';
const serviceData = {
    'ai-transformation': {
        title: 'AI Transformation',
        intro: 'Empower your business with intelligent automation, data-driven decisions, and adaptive workflows.',
        features: [
            {
                title: 'Strategic Automation',
                points: [
                    'Leverage AI agents to automate complex, rule-based workflows across multiple business functions',
                    'Reduce manual effort and human error by assigning repetitive tasks to intelligent systems.',
                    'Enable real-time decision-making through condition-based triggers and adaptive flows',
                    'Free up teams to focus on high-value, creative, and strategic work.',
                    'Ensure consistent execution of business processes at scale and speed'
                ]
            },
            {
                title: 'Data-Driven Intelligence',
                points: [
                    'Use AI to process and analyze structured and unstructured business data.',
                    'Generate actionable insights that drive smarter forecasting and planning decisions.',
                    'Identify patterns, anomalies, and trends that are not visible to the human eye.',
                    'Enable proactive business strategies based on predictive analytics and recommendations.',
                    'Continuously refine decisions as more data is collected and models improve.'
                ]
            },
            {
                title: 'Scalable Integration',
                points: [
                    'Embed AI capabilities into your existing tools like CRM, ERP, and support platforms',
                    'Enable seamless communication between AI agents and legacy systems via APIs.',
                    'Ensure consistent performance without disrupting current operations or workflows.',
                    'Allow users to interact with AI within familiar interfaces and business contexts.',
                    'Scale AI adoption incrementally, aligning with business priorities and readiness.'
                ]
            }
        ]
    },
    'it-modernization': {
        title: 'IT Modernization',
        intro: 'Upgrade your legacy systems to scalable, secure, cloud-first platforms.',
        features: [
            {
                title: 'Cloud-Native Migration',
                points: [
                    'TransformJet helps organizations migrate from outdated on-premise systems to modern, cloud-native infrastructure.',
                    'It ensures scalability, high availability, and cost optimization across AWS, Azure, or hybrid environments.',
                    'Legacy applications are re-engineered for better performance and security.',
                    'Cloud resources are dynamically managed to match workload demands.',
                    'This enables long-term flexibility and a future-proof foundation'
                ]
            },
            {
                title: 'DevOps & Automation',
                points: [
                    'TransformJet streamlines development and deployment through CI/CD pipelines and DevOps best practices.',
                    'It automates testing, builds, and releases to reduce manual errors and increase release speed',
                    'Teams can focus on innovation instead of repetitive tasks',
                    'Integrated monitoring and rollback mechanisms ensure reliability',
                    'This results in faster time-to-market and continuous improvement cycles'
                ]

            },
            {
                title: 'API-First Architecture',
                points: [
                    'TransformJet replaces monolithic systems with API-driven, service-oriented architectures.',
                    'This enables seamless integration across internal and third-party systems.',
                    'Modular services improve maintainability and scale independently.',
                    'APIs enhance collaboration between development teams and business units.',
                    'It paves the way for digital ecosystems and rapid product innovation.'
                ]
            }
        ]
    },
    'business-automation': {
        title: 'Business Automation',
        intro: 'Streamline your business workflows with end-to-end automation.',
        features: [
            {
                title: 'Workflow Orchestration',
                points: [
                    'TransformJet enables seamless automation of complex business workflows',
                    'Users can design and execute multi-step processes across teams using visual flows.',
                    'AI-driven triggers adapt actions based on real-time data and conditions',
                    'This reduces human error and ensures consistency in operations',
                    'It increases throughput while freeing up employee bandwidth'
                ]

            },
            {
                title: 'Task & Approval Automation',
                points: ['Routine tasks like status updates, approvals, and reminders are fully automated',
                    'TransformJet handles task assignments, deadline tracking, and notifications',
                    'Multi-level approval chains are built into workflows for compliance and speed.',
                    'Managers get full visibility with real-time status updates',
                    'This ensures efficiency and faster decision-making.'
                ]
            },
            {
                title: 'System  Integration',
                points: [
                    'TransformJet integrates core business tools (CRM, ERP, Finance, HRMS) via APIs.',
                    'It creates a connected ecosystem where data flows without duplication',
                    'Employees can access the right information from a single dashboard.',
                    'No more switching between tools or syncing issues.',
                    'This boosts productivity and data accuracy across the organization.'

                ]
            }
        ]
    }
};

const ServiceDetails = () => {
    const { slug } = useParams(); // ✅ grabs value from /services/:slug

    const service = serviceData[slug];

    useEffect(() => {
        window.scrollTo(0, 0); // scroll to top on mount
    }, []);

    if (!service) {
        return (
            <div className="container mt-5 text-center">
                <h3>Service Not Found</h3>
                <p>The requested service "{slug}" does not exist.</p>
            </div>
        );
    }

    return (
        <>
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="container position-relative d-flex align-items-center justify-content-between">

                    <a href="/" className="logo d-flex align-items-center me-auto me-xl-0">

                        <img
                            src={transformjetLogo}
                            alt="TransformJet"
                            height="50"
                            width="100"
                        />
                    </a>

                    <nav id="navmenu" className="navmenu">
                        <ul>
                            <li><Link to="/#hero">Home</Link></li>
                            <li><Link to="/#about">About Us</Link></li>
                            <li><Link to="/#solution">Solution</Link></li>
                            <li><Link to="/#why-choose-us">Why Choose Us</Link></li>
                            <li><Link to="/#pricing">Pricing</Link></li>
                            <li><Link to="/#team">Team</Link></li>
                            <li className="dropdown">
                                <a href="#"><span>Features</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                                <ul>
                                    <li><a href="#">AI Agent</a></li>

                                    <li><a href="#">Workflow</a></li>
                                    <li><a href="#">Integrations</a></li>

                                </ul>
                            </li>
                            <li><Link to="/#contact">Contact</Link></li>
                        </ul>
                        <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
                    </nav>
                    <Link to="/login"><a className="btn-getstarted" >Login</a></Link>

                </div>
            </header>
            <div className="service-details-page">
                {/* Page Title */}
                <div className="page-title dark-background">
                    <div className="heading">
                        <div className="container">
                            <div className="row d-flex justify-content-center text-center">
                                <div className="col-lg-8">
                                    <h1>{service.title}</h1>
                                    <p className="mb-0">{service.intro}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <nav className="breadcrumbs">
                        <div className="container">
                            <ol>
                                <li><a href="/">Home</a></li>
                                <li className="current">{service.title}</li>
                            </ol>
                        </div>
                    </nav>
                </div>

                {/* Service Details Section */}
                <section id="service-details" className="service-details section">
                    <div className="container">
                        <div className="row gy-4">
                            <div className="col-lg-4">
                                <div className="services-list">
                                    {Object.keys(serviceData).map(key => (
                                        <a
                                            key={key}
                                            href={`/services/${key}`}
                                            className={slug === key ? "active" : ""}
                                        >
                                            {serviceData[key].title}
                                        </a>
                                    ))}
                                </div>
                                <h4>{service.title}</h4>
                                <p>{service.intro}</p>
                            </div>

                            <div className="col-lg-8">
                                <img src={service_img} alt={service.title} className="img-fluid services-img mb-4" />
                                {service.features.map((feature, i) => (
                                    <div key={i} className="mb-4">
                                        <h3>{feature.title}</h3>
                                        <ul>
                                            {feature.points.map((point, j) => (
                                                <li key={j}>
                                                    <i className="bi bi-check-circle"></i> <span>{point}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>

    );
};

export default ServiceDetails;
